import MandatePreviewList from './MandatePreviewList'

export default MandatePreviewList
